import clsx from 'clsx';
import { CircleX } from 'lucide-react';
import { CSSProperties, DetailedHTMLProps, InputHTMLAttributes, ReactElement } from 'react';
import styles from './Input.module.scss';

export type InputProps = {
  label?: ReactElement | string;
  error?: ReactElement | string;
  inputStyle?: CSSProperties;
  fullWidth?: boolean;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export default function Input({
  label,
  error,
  style,
  inputStyle,
  fullWidth,
  ...props
}: InputProps) {
  return (
    <label
      className={clsx(styles.field, { [styles.error]: error != undefined })}
      style={{ width: fullWidth ? '100%' : 'auto', ...style }}
    >
      {label && <span className={styles.label}>{label}</span>}
      <span className={styles.inputWrapper}>
        <input style={inputStyle} {...props} />
        {error && (
          <span className={styles.errorLabel}>
            <CircleX size={14} />
            <span>{error}</span>
          </span>
        )}
      </span>
    </label>
  );
}
